/* eslint-disable
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./categorizerRulesUpload.scss');
require('ng-file-upload');

const deps = [
  'ngFileUpload',
  require('data/collection/categorizerRule').name,
  require('ui/web/notifications').name,
  require('ui/web/confirmDialog').name,
];

module.exports = angular
  .module('bench.ui.categorizerRulesUpload', deps)

  .directive('blCategorizerRulesUpload', $compile => ({
    restrict: 'E',
    scope: {
      rulesId: '=',
      uploadType: '@',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: require('./categorizerRulesUploadCtrl.js'),
    link(scope, element, attrs) {
      let template = '';

      switch (scope.vm.uploadType) {
        case 'button':
          template = `\
<button
    class="bl-button upload-button"
    ngf-select
    ng-model="vm.rawFile">
    Upload
</button>`;
          break;
        default:
          template = `\
<ng-file-drop
    class="file-uploader"
    ng-model="vm.rawFile"
    ng-file-change="vm.onDrop($files, $event, $rejectedFiles)"
    ng-multiple="true"
    dropAvailable="vm.dropSupported"
    stopPropagation="true"
    hideOnDropNotAvailable="true">
    <div class="file-uploader_info">
      <span class="file-uploader_text">
        <i class="file-uploader_icon bl-icon-create-new"></i>
        <p>You can drop that right here and we’ll take care of it for you.</p>
        <p>Thanks!</p>
      </span>
    </div>
</ng-file-drop>`;
      }

      element.html(template).show();

      return $compile(element.contents())(scope);
    },
  }));
